import { render, staticRenderFns } from "./rzrqDetail.vue?vue&type=template&id=38d86ff4&scoped=true&"
import script from "./rzrqDetail.vue?vue&type=script&lang=js&"
export * from "./rzrqDetail.vue?vue&type=script&lang=js&"
import style0 from "./rzrqDetail.vue?vue&type=style&index=0&id=38d86ff4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d86ff4",
  null
  
)

export default component.exports